export default "__VITE_ASSET__DjY_By4A__"